// extracted by mini-css-extract-plugin
export default {"root":"EdP9A9"};